<template>
  <RoomMap class="select-none">
    <TransitionGroup
      enter-from-class="opacity-0"
      enter-active-class="ease-in-out duration-300"
      enter-to-class="opacity-100"
    >
      <PerformanceRoomTable
        @click="handleTableSelection(table)"
        v-for="table in tables"
        :draggable="draggable"
        :key="table.id"
        :table="table"
        :reservationStatus="table.reservationStatus"
        :updateStatus="table.updateStatus"
        :filled="_.includes(filledTableIds, table.id)"
        :lowOpacity="_.includes(lowOpacityTableIds, table.id)"
      />
    </TransitionGroup>
  </RoomMap>
</template>

<script setup lang="ts">
import * as _ from 'lodash-es'
import { storeToRefs } from 'pinia'
import { toRefs } from 'vue'

import RoomMap from '@/common/components/organisms/RoomMap.vue'
import PerformanceRoomTable from '@/modules/performance/components/molecules/PerformanceRoomTable.vue'
import { PerformanceTableEvent } from '@/modules/performance/interfaces/PerformanceTableInterfaces'
import {
  PerformanceTableWithReservations,
  usePerformanceReservationStore,
} from '@/modules/performance/stores/PerformanceReservationStore'

const emit = defineEmits<{
  // eslint-disable-next-line no-unused-vars
  (e: 'table:click', tableEvent: PerformanceTableEvent): void
}>()

const props = defineProps<{ tables: PerformanceTableWithReservations[]; draggable: boolean }>()
const { tables } = toRefs(props)

const performanceReservationStore = usePerformanceReservationStore()
const { lowOpacityTableIds, filledTableIds } = storeToRefs(performanceReservationStore)
function handleTableSelection(table: PerformanceTableWithReservations) {
  const tableIndex = _.findIndex(tables.value, { id: table.id })
  emit('table:click', {
    tableId: table.id,
    tableIndex,
    activeReservationId: table.activeReservation?.id || null,
  })
}
</script>
